<script setup lang="ts">
import popupImg from '@/assets/popup.png'
import { useAuthStore } from '@/stores/auth'
import { onMounted } from 'vue'

const authStore = useAuthStore()
const hidePopup = () => {
  authStore.setHidePromoPopup()
}
onMounted(() => {
  const closeTime = setTimeout(() => {
    authStore.setHidePromoPopup()
    clearTimeout(closeTime)
  }, 10000)
})
</script>

<template>
<div class="popup" @click="hidePopup">
  <img class="image" :src="popupImg" alt="Promo">
</div>
</template>

<style scoped lang="less">
.popup {
  position: absolute;
  z-index: 150;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgb(0 0 0 / 80%);
  .image {
    max-width: 100%;
  }
}
</style>
